
<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
               style="background-image: url(../../assets/techbanner.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" style="padding-top: 40px;">
                    <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">We drive towards what matters to you</h1></div>
                    <div>
                        <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">WebSoulLabs as a 
                            fast growing web development company, we focus in bringing a distinctive approach to the application 
                            development through viable.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>    

    




<div class="uk-section" style="padding-top: 50px;">
<div class="uk-container">
        
    <div class="web-part">
        <div><h2 class="uk-text-left uk-text-secondary uk-text-bolder" style="margin-bottom: 10px; font-weight: 600;">Web development</h2></div>
        <div><p class="uk-text-medium uk-text-justify" style="font-size: 18px;">We have a team of Web Developers who design and
            develop Web Applications such as Enterprise Level Web Applications, Content Management 
            Systems, E-Commerce Websites, Web API’s, Laravel, Codeigniter and many more. We keep top
            quality standards and blend the latest innovations in our software development projects.
            Our sites are always compatible with the present changing devices and platforms. We
            develop websites which are responsive in all devices. We are capable of building small 
            business websites and top–notch corporate E-commerce web portals using the latest 
            technology.</p>
        </div>
    
    <div>
        <div> 
            <div class="uk-grid-column-small uk-grid-row-large uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m   uk-child-width-1-6@l  uk-text-center " uk-grid>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">
        
                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/webphp1.jpg" width="100" height="100"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up">Php</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/CakePHP.png" width="100" height="100"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up ">Cake PHP<br></h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/laravel.png" width="100" height="100"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up ">Laravel</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/codeigniter.jpg" width="70" height="70"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up" style="margin-top: 55px;" >Code Igniter</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/icons/kohana.png" width="100" height="100"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up"style="margin-top: 40px;" >Kohana PHP</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/node.png" width="125" height="125"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up" style="margin-top: 45px;">Node JS</h4>
                    </div>
                </div>
            
                <div>
                    <div class="uk-animation-toggle" tabindex="0">
                        <div class="uk-animation-scale-up">
                    <img class="uk-align-center" src="../../assets/ruby.jpg" width="100" height="100"  alt="web">
                    <h4 class="uk-text-center">Ruby on rails</h4>
                    </div>
                    </div>
                </div>
                    <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/web3.png" width="100" height="100"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up">Angular js</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/vuejs.jpg" width="100" height="100"   alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up ">Vue js</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/web2.png" width="100" height="100"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up">Python</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/django.png" width="100" height="100" alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up">Django</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/wordp.png" width="100" height="100"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up">Wordpress</h4>
                    </div>
                </div>
            

                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/drupal.png" width="100" height="100"  alt="web">
                    <h4 class=" uk-text-center uk-animation-scale-up">Drupal</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/joomla.png" width="100" height="100"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up ">Joomla</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/HTML5.png" width="100" height="100"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up ">Html 5</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/css111.png" width="70" height="70"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up">Css</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/scss.jpg" width="100" height="100"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up ">Scss</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/boo.png" width="120" height="120"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up">Bootstrap</h4>
                    </div>
                </div>
            
       <br><br>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">
                        
                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/mysql.png" width="90" height="90"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up">Mysql</h4>
                    </div>
                        
                </div>
                <div>
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up " src="../../assets/Postgresql.png" width="90" height="90"  alt="web">
                    <h4 class=" uk-text-center uk-animation-scale-up ">Postgre SQL</h4>
                    </div>
                </div>
                <div>
                
                    <div class="uk-animation-toggle" tabindex="0">

                    <img class="uk-align-center uk-animation-scale-up" src="../../assets/mongodb.png" width="90" height="90"  alt="web">
                    <h4 class="uk-text-center uk-animation-scale-up">MongoDB</h4>
                    </div>
                </div>
            </div>
        </div>   <!---->
    </div> 

     <!--web dev icon div-->
    </div>
    <br><br>
       
    <div class="mobile-part">
       <div><h2 class="uk-text-left uk-text-secondary uk-text-bolder " style="margin-bottom: 10px; font-weight: 600;">Mobile development</h2></div>
       <div><p class="uk-text-medium uk-text-justify" style="font-size: 18px;">WebSoulLabs, is a countable
            name for developing innovative and sophisticated mobile applications that helps you to standout in
            your business regime and capture wider audience for business benefits. WebSoulLabs have a vibrant
            team of professional app designers with tremendous talent that renders endless solutions to all
            your mobile application development requirements. We targets on implementing focused and
            vigorous strategies to deploy feature rich and powerful applications.</p>
        </div>
       
    
    </div>         
    <div>  
        <div class="uk-grid-column-small uk-grid-row-large uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m   uk-child-width-1-6@l  uk-text-center" uk-grid>
            <div>
                <div class="uk-animation-toggle" tabindex="0">

                <img class="uk-align-center uk-animation-scale-up" src="../../assets/mobile1.jpg" width="100" height="100"  alt="web">
                <h4 class="uk-text-center uk-animation-scale-up">ios</h4>
                </div>
            </div>
            <div>
                <div class="uk-animation-toggle" tabindex="0">

                <img class="uk-align-center uk-animation-scale-up" src="../../assets/andr111.jpg" width="100" height="100"  alt="mobileapp">
                <h4 class="uk-text-center uk-animation-scale-up">Android</h4>
                </div>
            </div>
            <div>
                <div class="uk-animation-toggle" tabindex="0">

                <img class="uk-align-center uk-animation-scale-up" src="../../assets/swift.jpg" width="100" height="100"  alt="mobileapp">
                <h4 class="uk-text-center uk-animation-scale-up">Swift</h4>
                </div>
            </div>
            <div>
                <div class="uk-animation-toggle" tabindex="0">

                <img class="uk-align-center uk-animation-scale-up" src="../../assets/mobile3.jpg" width="100" height="100"  alt="mobileapp">
                <h4 class="uk-text-center uk-animation-scale-up">Java</h4>
                </div>
            </div>
            <div>
                <div class="uk-animation-toggle" tabindex="0">

                <img class="uk-align-center uk-animation-scale-up" src="../../assets/mobile2.jpg" width="100" height="100"  alt="mobileapp">
                <h4 class="uk-text-center uk-animation-scale-up">React JS</h4>
                </div>
            </div>
            <div>
                <div class="uk-animation-toggle" tabindex="0">

                <img class="uk-align-center uk-animation-scale-up" src="../../assets/xamarin111.png" width="100" height="100"  alt="mobileapp">
                <h4 class="uk-text-center uk-animation-scale-up">Xamarin</h4>
                </div>
            </div>
        
        <br><br>
            
            <div>
                <div class="uk-animation-toggle" tabindex="0">

                <img class="uk-align-center uk-animation-scale-up" src="../../assets/Fabric.png" width="80" height="80"  alt="web">
                <h4 class="uk-text-center uk-animation-scale-up">Fabric</h4>
                </div>
            </div>
            <div>
                <div class="uk-animation-toggle" tabindex="0">

                <img class="uk-align-center uk-animation-scale-up " src="../../assets/kotlin111.jpg" width="80" height="80"  alt="web">
                <h4 class="uk-text-center uk-animation-scale-up ">Kotlin</h4>
                </div>
            </div>
        </div>          <!--mobil dev last div-->
    </div>
    <br><br> 
    <div class="ecommerce-part">
       <div><h2 class="uk-text-left uk-text-secondary uk-text-bolder" style="margin-bottom: 10px; font-weight: 600;">E-commerce development</h2></div>
       <div><p class="uk-text-medium  uk-text-justify" style="font-size: 18px;">WebSoulLabs delivers top-level E-commerce web 
           development services with the promising software and evolution strategies catered to every
            customer’s distinct requirements. We have an enthusiastic squad of specialist professionals,
            creators and project executives to assure our clients receive a profitable evolution process.
            We are delivering a wide span of E-commerce development services such as E-commerce web
            development, design, testing, support and maintenance.</p>
        </div>
       
    <div>
        <div class="uk-grid-column-small uk-grid-row-large uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m   uk-child-width-1-6@l  uk-text-center" uk-grid>
            <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/e.jpg" width="100" height="100"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">Magento</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/e1.jpg" width="100" height="100"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">Shopify</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/e2.png" width="100" height="100"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">Woo Commerce</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/e3.jpg" width="100" height="100"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">OpenCart</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/stripe.jpg" width="100" height="100"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">Stripe</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/paypal.png" width="80" height="80"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">Paypal</h4>
               </div>
           </div>
        
       <br><br>
           
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/braintree.png" width="200" height="200"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">Braintree</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/2co.png" width="90" height="90"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">2Checkout</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/CCAvenue.jpg" width="80" height="80"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">CC Avenue</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/aramex.png" width="200" height="200"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">Aramex</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/FedEx.png" width="150" height="50"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">FedEx</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/ups1.png" width="40" height="40"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">UPS</h4>
               </div>
           </div>
                  
       <br><br>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/USPS.png" width="130" height="130"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">USPS</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/Royal Mail.png" width="130" height="130"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">Royal Mail</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/XE.png" width="100" height="100"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">XE</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/OER.png" width="70" height="70"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">OER</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/twilio1.png" width="100" height="100"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up" style="margin-top: 30px;">Twilio</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/Google111.jpg" width="100" height="100"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up" style="margin-top: 30px;">Google Analytics</h4>
               </div>
           </div>
                 
       <br><br>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/sparlepost.png" width="50" height="50"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">Sparle Post</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/payfort.jpg" width="120" height="120"  alt="e-commerce icons">
               <h4 class="uk-text-center uk-animation-scale-up">PayFort</h4>
               </div>
           </div>
        </div>  <!--ecomm last icon div-->
    </div>
    </div> 
    <br><br>                          
    <div class="gigital-part">
       <div><h2 class="uk-text-left uk-text-secondary uk-text-bolder" style="margin-bottom: 10px; font-weight: 600;">Digital marketing </h2></div>
       <div><p class="uk-text-medium uk-text-justify" style="font-size: 18px;">The work culture of a
          modernistic Digital Marketing company is different from Traditional Marketing Company. We are a
          clan of open to various potentials kind of Digital enthusiasts who just want to make the best 
          of Digital Marketing expertise for your company. WebSoulLabs specialize in all Digital Marketing 
          services like SEO, SMO, and SEM, Social media Marketing, Email Marketing, and Content Marketing
           etc</p>
        </div>
       <br><br>
    <div>
        <div class="uk-grid-column-small uk-grid-row-large uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m   uk-child-width-1-6@l  uk-text-center" uk-grid>
            <div>
               <div class="uk-animation-toggle" tabindex="0">

               <img class="uk-align-center uk-animation-scale-up" src="../../assets/digit.jpg" width="100" height="100"  alt="digital marketind apps">
               <h4 class="uk-text-center uk-animation-scale-up">Twitter</h4>
               </div>
           </div>
           <div>
               <div class="uk-animation-toggle" tabindex="0">
       
               <img class="uk-align-center uk-animation-scale-up" src="../../assets/digit1.jpg" width="100" height="100"  alt="digital marketind apps">
               <h4 class="uk-text-center uk-animation-scale-up">Instagram</h4>
               </div>
           </div>           
           <div>
               <div class="uk-animation-toggle" tabindex="0">
       
               <img class="uk-align-center uk-animation-scale-up" src="../../assets/digit2.jpg" width="100" height="100"  alt="digital marketind apps">
               <h4 class="uk-text-center uk-animation-scale-up">LinkedIn</h4>
               </div>
           </div> 
           <div>
               <div class="uk-animation-toggle" tabindex="0">
       
               <img class="uk-align-center uk-animation-scale-up" src="../../assets/digit3.jpg" width="100" height="100"  alt="digital marketind apps">
               <h4 class="uk-text-center uk-animation-scale-up">Facebook</h4>
               </div>
           </div>       
       </div>                      <!--digit mark icon div-->
    </div>
    </div>

 

    

   








</div>    <!--container-large from web to digital  div--> 
</div>  
